import Vue from 'vue'
import Vuex from 'vuex'
import {documentsCollection} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
    state: {
      data:{
        name: '',
        haveIGV: false,
        isInputCategory: false,
        isOutputCategory: false,
        isInputDefaultDocument: false,
        isOutputDefaultDocument: false,
        serialNumbers:[],
      },
      record:{},
      selectedKey: '',
      dialog: false
    },
    mutations: {
      cleanSelectedKey:(state)=>{
        state.selectedKey=''
      },
      getAllItems(state, item) {
        Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
      },
      clean(state,key){
        Vue.delete(state.record,key)
      }        
    },
    actions: {
      getAll:(context)=>{
        context.state.record = {}
        documentsCollection.orderBy('name', 'asc').get().then(data=>data.docs.map( item => context.commit( 'getAllItems', item  ) ) )
        
      },
      add:context=>{
        if(context.state.selectedKey==''){
          documentsCollection.add({...context.state.data, createdAt:new Date, serialNumbers: context.state.data.serialNumbers.map(item => ({...item, numeration: Number(item.numeration)})) }).then(()=>{
            context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo tipo de recibo correctamente', { root: true })
            context.dispatch('cleanForm')
          })
           
        } else {
          documentsCollection.doc(context.state.selectedKey).update({...context.state.data, updateAt: new Date(), serialNumbers: context.state.data.serialNumbers.map(item => ({...item, numeration: Number(item.numeration)}) )}).then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
            context.dispatch('cleanForm')
            context.state.selectedKey = ''
          })
        }
        context.state.dialog = false
      },
      clean:(context, key)=>{
        documentsCollection.doc(key).delete().then(()=>{
          context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
          context.commit('clean', key)})
      },
      get:(context, key)=>{
        documentsCollection.doc(key).get().then(doc=>{
          context.state.data = doc.data()
          context.state.selectedKey = key
          context.state.dialog = true
        })
      },
      cleanForm: context => {
          context.state.selectedKey = ''
          context.state.data = {
          name: '',
          haveIGV: false,
          isInputCategory: false,
          isOutputCategory: false,
          isInputDefaultDocument: false,
          isOutputDefaultDocument: false,
          serialNumbers:[],
        }
      },
      getNextNumeration: (context, data)=>{
        let dataToAnalice = [...data.content.serialNumbers]
        let index = dataToAnalice.findIndex(item => item.name == data.serialNumber)
        let newNumber = !data.newNumber ? data.content.serialNumbers[index].numeration + 1 : data.newNumber
        let newSerialNumber = data.content.serialNumbers
        newSerialNumber[index] = {...newSerialNumber[index], numeration: newNumber}

        return ({newSerialNumber, newNumber})
      },
      updateNumeration: (context, data) => {
        numerationCollection.doc(data.key).update({number: data.number}).then(()=>context.commit('Helpers/launchSnackbar', 'Numeración actualizada', { root: true }))
      }
    },
    getters: {
      record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item, name: state.record[item].code + ' - ' + state.record[item].name }) ),
      inputDocumentsRecord: state => Object.keys(state.record).filter(item => state.record[item].isInputCategory).map(item => ({...state.record[item], key: item }) ),
      outputDocumentsRecord: state => Object.keys(state.record).filter(item => state.record[item].isOutputCategory).map(item => ({...state.record[item], key: item }) ),

    },
  }
  